var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, Col, Row } from '@digitools/honest-react';
import TranslationProvider from '../../providers/TranslationProvider';
import { Language } from '../../types/Language';
import Header from './Header/Header';
import { HeaderDictionaryEn } from './i18n/HeaderDictionaryEn';
import { HeaderDictionaryEs } from './i18n/HeaderDictionaryEs';
import UtilityHeader from './UtilityHeader/UtilityHeader';
var HeaderContainer = function () {
  var _a;
  return _jsxs(TranslationProvider, __assign({
    dictionaries: (_a = {}, _a[Language.ENGLISH] = HeaderDictionaryEn, _a[Language.SPANISH] = HeaderDictionaryEs, _a)
  }, {
    children: [_jsx(UtilityHeader, {}), _jsx(Container, __assign({
      size: 'medium'
    }, {
      children: _jsx(Row, {
        children: _jsx(Col, {
          children: _jsx(Header, {})
        })
      })
    }))]
  }));
};
export default HeaderContainer;